var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_taktarea == true)?_c('div',{class:`trainhead taktarea-head ${_vm.backlog?'backlog':'train'}`,style:(_vm.zoom?
  `
  width: calc((var(--workpackage_width) + 4px) * ${_vm.zoom});
  height: calc((var(--workpackage_height) + 4px) * ${_vm.zoom});
  margin: calc(2px * ${_vm.zoom});
  `
  :'')}):_c('div',{class:`trainhead ${_vm.backlog?'backlog':'train'}`,style:(`
    background-color: ${_vm.color ? _vm.getColor(_vm.color) : _vm.getColor('color-3')};
    ${_vm.zoom
      ?
        `width: calc((var(--workpackage_width) + 4px) * ${_vm.zoom});
        height: calc((var(--workpackage_height) + 4px) * ${_vm.zoom});
        margin: calc(2px * ${_vm.zoom});`
      :
        ''}`)},[(!_vm.zoom && _vm.edit_mode)?_c('v-icon',{staticClass:"swap-arrow"},[_vm._v("swap_vert")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }